import { useRef, useEffect } from 'react';

import MultiLanguageUpload from '@Components/BasicComponents/MultiLanguageUpload';
import Validate from '@Components/Validate';


import { fileRequired, filesUploaded, numberRequired} from '@/utils/errors/list';
import { checkInfograficNames } from '@/utils/names';
import { getSetting } from '@/utils/settings';

import useIbmS3Uploader from '@/hooks/useIbmS3UploaderNew';
import useNotification from '@/hooks/notifications';

const tooltips = {
	jpg: 'Options for selecting or indicating the file format of the uploaded media, specifying the image or graphic type. The filename must use the following convention for infographic files: {referenceID}_{nnn}[{language}-infographics].jpg.',
	png: 'Options for selecting or indicating the file format of the uploaded media, specifying the image or graphic type. The filename must use the following convention for infographic files: {referenceID}_{nnn}[{language}-infographics].png.',
	pdf: 'Options for selecting or indicating the file format of the uploaded media, specifying the image or graphic type. The filename must use the following convention for infographic files: {referenceID}_{nnn}[{language}-infographics].pdf.',
	ai: 'Options for selecting or indicating the file format of the uploaded media, specifying the image or graphic type. The filename must use the following convention for infographic files: {referenceID}_{nnn}[{language}-infographics].ai.',
	psd: 'Options for selecting or indicating the file format of the uploaded media, specifying the image or graphic type. The filename must use the following convention for infographic files: {referenceID}_{nnn}[{language}-infographics].psd.',
	svg: 'Options for selecting or indicating the file format of the uploaded media, specifying the image or graphic type. The filename must use the following convention for infographic files: {referenceID}_{nnn}[{language}-infographics].svg.',
};

const accept = {
	jpg: 'image/jpeg',
  png: 'image/png',
  pdf: '.pdf',
  ai: '.ai',
  psd: '.psd',
  svg: '.svg',
};

const types = [
	{title: 'PNG files upload *', value: 'png'},
	{title: 'JPEG files upload', value: 'jpg'},
  {title: 'PDF files upload', value:'pdf'},
  {title: 'Adobe Illustrator files upload', value:'ai'},
  {title: 'AdobePhotoshop files upload', value:'psd'},
  {title: 'SVG files upload', value:'svg'},
];

const requirements = {
	png: [filesUploaded, numberRequired, fileRequired],
	jpg: [filesUploaded],
	vector: [filesUploaded],
	pdf: [filesUploaded],
	ai: [filesUploaded],
	psd: [filesUploaded],
	svg: [filesUploaded],
};


export default function InfographicUpload ({selector, ...props}) {
	const {multilanguageFiles, epId, setMultilanguageFiles, removeMultilanguageFilesByUid, countryCode, setCountryCode} = selector();

	const {openNotification} = useNotification();

	const useIbmS3UploaderRef = useRef(
		useIbmS3Uploader({
			setFile: setMultilanguageFiles,
			removeFile: removeMultilanguageFilesByUid,
			bucketPrefix: epId.data + '/',
			bucketName: getSetting('ibmS3TempBucket'),
		}
	));
	const {handleUpload, updateBucketPrefix, handleRemove} = useIbmS3UploaderRef.current;

	useEffect(() => {
		updateBucketPrefix(epId.data + '/');
	}, [epId.data]);

	return <>
		{
			types.map((type, index) =>
				<div key={type.value}>
					<Validate requirements={requirements[type.value]}>
						<MultiLanguageUpload
							value={multilanguageFiles[type.value] || {}}
							handleUpload={({file, countryCode,}) => handleUpload({file, type: type.value, countryCode})}
							beforeUpload={checkInfograficNames({id: epId.data, openNotification, language: countryCode})}
							handleRemove={(file, countryCode) => handleRemove(file, countryCode, type.value)}
							accept={accept[type.value]}
							tooltip={tooltips[type.value]}
							title={type.title}
							countryCode={countryCode}
							setCountryCode={setCountryCode}
							allowRemoveOnErrorOnly
							{...props}
						/>
					</Validate>
					{index < types.length - 1 && <br/>}
				</div>
			)
		}
	</>;
}